// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { ArticleAuthor } from '../ArticleAuthor';
let FeaturedAuthors = class FeaturedAuthors extends Vue {
    constructor() {
        super(...arguments);
        this.isNextVisible = false;
        this.isPrevVisible = false;
    }
    goNext() {
        this.sliderRef.scrollLeft += this.sliderRef.clientWidth;
        setTimeout(this.updateArrows, 500);
    }
    goPrev() {
        this.sliderRef.scrollLeft -= this.sliderRef.clientWidth;
        setTimeout(this.updateArrows, 500);
    }
    updateArrows() {
        this.isNextVisible = this.sliderRef.scrollLeft < this.sliderRef.scrollWidth - this.sliderRef.clientWidth;
        this.isPrevVisible = this.sliderRef.scrollLeft > 0;
    }
};
__decorate([
    Prop({ type: Array, required: true })
], FeaturedAuthors.prototype, "authors", void 0);
__decorate([
    Prop({ type: String, required: false })
], FeaturedAuthors.prototype, "prefix", void 0);
__decorate([
    Ref('slider')
], FeaturedAuthors.prototype, "sliderRef", void 0);
FeaturedAuthors = __decorate([
    Component({
        name: 'FeaturedAuthors',
        components: { ArticleAuthor },
        template: `
    <div class="FeaturedAuthors">
      <span v-if="prefix" class="FeaturedAuthors__prefix">
        {{ prefix }}
      </span>

      <div class="FeaturedAuthors__slider">
        <button class="FeaturedAuthors__slider__prev" :class="{ '--visible': isPrevVisible }" @click="goPrev">
          <D24Icon name="chevron-left" size="small" />
        </button>

        <ul class="FeaturedAuthors__slider__inner list-unstyled" ref="slider">
          <li v-for="author in authors" :key="author.id" class="FeaturedAuthors__slider__item">
            <ArticleAuthor :author="author" :showInitialsWhenNoAvatar="true" />
          </li>
        </ul>

        <button class="FeaturedAuthors__slider__next" :class="{ '--visible': isNextVisible }" @click="goNext">
          <D24Icon name="chevron-right" size="small" />
        </button>
      </div>
    </div>
  `,
        mounted() {
            this.updateArrows();
        }
    })
], FeaturedAuthors);
export { FeaturedAuthors };
